import cloudinary from 'cloudinary-core';
const cl = cloudinary.Cloudinary.new();
cl.fromDocument();

export const defaultImageFormat = 'jpg';

export const getPath = function(publicId, transformation, cdnCode) {
    const src = cl.url(publicId, {
        transformation,
        format: defaultImageFormat,
        private_cdn: true,
        cname: `idemo-${cdnCode}.cloudinary.com`,
        secure_distribution: `idemo-${cdnCode}.cloudinary.com`
    });
    return src;
};

// Strip host since backend is checking against different CDN providers
// Changes
//  https://res.cloudinary.com/idemo/image/upload/ar_200:131,c_fill,dpr_2.0,g_faces,w_1200/sofa_cat.jpg
// to
//  /image/upload/ar_200:131,c_fill,dpr_2.0,g_faces,w_1200/sofa_cat.jpg
export const getRemotePartialPath = function(image, transformation, city) {
    const href = cl.url(image.public_id, { transformation, format: defaultImageFormat });
    const path = '/' + href
    .split('/')
    .slice(4)
    .join('/');
    return path;
};



/** WEBPACK FOOTER **
 ** ./src/js/components/MultiCdn/MultiCdnUtils.js
 **/